import React, { useCallback } from 'react';
import { batch } from 'react-redux';

import {
  CLASS_TEMPLATE_BULK_UPDATE_TYPES,
  CONTEST_LESSON_INPUT_OPTIONS,
  EditLessonForm,
  setBulkUpdateSyncConfirmModalState,
  setBulkUpdateSyncType,
} from 'features/classCreation';
import BulkUpdateSyncButton from '../BulkUpdateSyncButton';
import Discussion from '../Discussion';
import EditableSection from 'components/EditableSection';
import Field from 'components/Field';
import GroupContestSummary from '../GroupContestSummary';
import useAppDispatch from 'hooks/useAppDispatch';

export default function EditContestForm({ academyTopic }) {
  const dispatch = useAppDispatch();
  const lessons = academyTopic?.lessons;
  const { meta } = lessons[0] || {};
  const { is_group_contest: isGroupContest } = meta || {};

  const handleBulkUpdateSyncing = useCallback(
    (bulkUpdateSyncType) => {
      batch(() => {
        dispatch(setBulkUpdateSyncType(bulkUpdateSyncType));
        dispatch(setBulkUpdateSyncConfirmModalState(true));
      });
    },
    [dispatch]
  );

  return (
    <>
      <Field
        label="Contest Requirements"
        labelClassName="m-b-xs"
        actions={
          <BulkUpdateSyncButton
            handleOnSync={() =>
              handleBulkUpdateSyncing(CLASS_TEMPLATE_BULK_UPDATE_TYPES.lessons)
            }
          />
        }
      >
        {lessons.map((lesson) => {
          const label = CONTEST_LESSON_INPUT_OPTIONS[lesson.lesson_type]?.label;

          return (
            <div key={lesson.id}>
              {label && (
                <EditableSection
                  canEdit={!isGroupContest}
                  title={label}
                  titleClassName="hint"
                  className="m-b-s"
                  key={lesson.id}
                >
                  {(editableProps) => (
                    <EditLessonForm
                      {...editableProps}
                      academyTopicId={academyTopic.id}
                      value={lesson}
                      label={label}
                    />
                  )}
                </EditableSection>
              )}
            </div>
          );
        })}
      </Field>
      {isGroupContest && (
        <EditableSection
          title="Group Contest Summary"
          titleClassName="bold dark"
          className="m-b-s"
          canEdit={false}
        >
          {(editableProps) => (
            <GroupContestSummary
              {...editableProps}
              academyTopic={academyTopic}
            />
          )}
        </EditableSection>
      )}
      <Discussion academyTopic={academyTopic} />
    </>
  );
}
